export const tenantInitials = (tenantName: string): string => {
  const [first, second] = tenantName.split(' ')
  if (!second) {
    return ((first[0] ?? '') + (first[1] ?? '')).toUpperCase()
  }
  return ((first[0] ?? '') + (second[0] ?? '')).toUpperCase()
}
